import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { Modal as ModalMUI, IconButton } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import CloseIcon from '@mui/icons-material/Close';
import styles from './Lightbox.module.scss';
import { StrapiMediaCollection } from '../../models/Strapi';

type LightboxProps = {
    open: boolean
    fotos: StrapiMediaCollection['data']
    initialIndex: number
    onClose: (index: number) => void
}

const Lightbox = ({ open, fotos, initialIndex, onClose }: LightboxProps) => {

  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const [current, setCurrent] = useState(initialIndex);

  // Al abrir, el swiper del lightbox debe arrancar en la misma foto que
  // estaba activa en el carrusel principal, no en la primera.
  useEffect(() => {
    if (open && swiperInstance) {
      swiperInstance.slideToLoop(initialIndex, 0);
      setCurrent(initialIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!fotos?.length) return null;

  return (
    <ModalMUI
      open={open}
      onClose={() => onClose(current)}
      className={styles.modal}
    >
      <div className={styles.contenedor}>
        <IconButton
          className={styles.cerrar}
          aria-label="Cerrar"
          onClick={() => onClose(current)}
        >
          <CloseIcon />
        </IconButton>

        {fotos.length > 1 &&
          <div className={styles.contador}>{current + 1} / {fotos.length}</div>
        }

        <Swiper
          onSwiper={setSwiperInstance}
          modules={[Navigation, Keyboard]}
          keyboard={{ enabled: true }}
          initialSlide={initialIndex}
          spaceBetween={0}
          slidesPerView={1}
          loop={fotos.length > 1}
          navigation={fotos.length > 1}
          onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
          className={styles.swiper}
        >
          {fotos.map((item) => (
            <SwiperSlide key={item.id} className={styles.slide}>
              <div className={styles.imagenWrapper}>
                <Image
                  className={styles.imagen}
                  src={item.attributes.formats?.large?.url || item.attributes.url}
                  alt={item.attributes.alternativeText || 'We Celebrate'}
                  fill
                  sizes="90vw"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </ModalMUI>
  );
};

export default Lightbox;
